import React from 'react';
import { useParams } from 'react-router-dom';

import ListModelNavigation from '@dashboard/components/ListModelNavigation';
import { useGroupsListHref } from '@dashboard/hooks/route/hrefs';

export default function Navigation() {
  const id = useParams<{ id: string }>().id!;
  const getLinkHref = (id: string) => `../groups/${id}`;
  const backLinkHref = useGroupsListHref();
  return <ListModelNavigation currentModelId={id} backLinkHref={backLinkHref} getLinkHref={getLinkHref} />;
}
